(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/iam-idp/assets/javascripts/react/components/shared/selector-buttons.js') >= 0) return;  svs.modules.push('/modules/iam-idp/assets/javascripts/react/components/shared/selector-buttons.js');


'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _svs$ui$ReactItemsMen = svs.ui.ReactItemsMenu,
  ItemsMenu = _svs$ui$ReactItemsMen.ItemsMenu,
  LinkItem = _svs$ui$ReactItemsMen.LinkItem;
const _jotai = jotai,
  useAtomValue = _jotai.useAtomValue,
  useAtom = _jotai.useAtom;
const _svs$iam_idp$atoms = svs.iam_idp.atoms,
  isPollingAtom = _svs$iam_idp$atoms.isPollingAtom,
  activeMethodAtom = _svs$iam_idp$atoms.activeMethodAtom;
const loginMethods = svs.iam_idp.constants.loginMethods;
const SelectorButtons = () => {
  const isPolling = useAtomValue(isPollingAtom);
  const _useAtom = useAtom(activeMethodAtom),
    _useAtom2 = _slicedToArray(_useAtom, 2),
    activeMethod = _useAtom2[0],
    setActiveMethod = _useAtom2[1];
  const onMethodClick = method => {
    setActiveMethod(method);
  };
  return (!isPolling || svs.core.detect.formfactor.desktop() && isPolling) && React.createElement(ItemsMenu, {
    branding: "sport",
    centered: true,
    className: "login-selector",
    hiddenScrollbar: true,
    useScrollFaders: true,
    useScrollHelpers: true
  }, React.createElement(LinkItem, {
    "aria-label": "Logga in med BankID",
    label: "BANKID",
    onClick: () => onMethodClick(loginMethods.bankid),
    selected: activeMethod === loginMethods.bankid
  }), React.createElement(LinkItem, {
    "aria-label": "Logga in med Freja eID",
    label: "FREJA EID",
    onClick: () => onMethodClick(loginMethods.freja),
    selected: activeMethod === loginMethods.freja
  }));
};
svs.iam_idp.components.shared.SelectorButtons = SelectorButtons;

 })(window);